import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-calificaciones-prefectos">
            <div className= "titulo-calificaciones-prefectos">
                <h2>
                    Calificaciones (Materias)
                </h2>
            </div>
        </div>      
    );
};

export default Header;